import { createAsyncThunk } from '@reduxjs/toolkit'
import { callErrorMsg } from 'helpers/errorMsg'

import { getPrincipalListAPI } from 'features/AdsManagement/services/principalList'
import { normalizeApprovalListPaginationCursors } from 'features/AdsManagement/helpers/normalizeApprovalListCursor'

import { setIsLoading, setPrincipalList, setPagination } from './slice'

const SLICE_NAME = 'adsPrincipalList'

export const fetchPrincipalList = createAsyncThunk(
  `${SLICE_NAME}/fetchPrincipalList`,
  async (
    { name, page_size, cursor }: { name: string; page_size: number; cursor?: string },
    { rejectWithValue, dispatch },
  ) => {
    dispatch(setIsLoading(true))
    try {
      const response = await getPrincipalListAPI({
        seller_name: name,
        page_size,
        page_cursor: cursor,
      })
      dispatch(setPrincipalList(response.data.data.credit_balances))
      dispatch(setPagination(normalizeApprovalListPaginationCursors(response.data.pagination)))
      dispatch(setIsLoading(false))

      return true
    } catch (error) {
      dispatch(setIsLoading(false))
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)
